import { useMemo } from 'react';
import { FlowMode } from '~/models/FlowMode';
import { ProductType } from '~/models/product/ProductType';
import { mapCampaignData, useCampaign } from '~/store/campaign/api';

export const useMappedCampaign = (partnerAlias: string, dwellingUnit: string, campaignUrl: string) => {
  const { data, ...rest } = useCampaign(partnerAlias, dwellingUnit, campaignUrl);

  const mappedCampaign = useMemo(() => mapCampaignData(data), [data]);

  return { ...rest, data: mappedCampaign };
};
export type MappedCampaign = NonNullable<ReturnType<typeof useMappedCampaign>['data']>;

export const getFlowMode = (type: ProductType): FlowMode => {
  switch (type) {
    case ProductType.Receiver:
    case ProductType.Equipment:
      return FlowMode.Progressive;
    default:
      return FlowMode.Open;
  }
};
